<template>
  <v-container>
    <page-header :title="lang.welcome" />
    <div v-html="contents" :class="['font-weight-light', 'meta-description']" />
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'index',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      contents: null
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Mounted event handler
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      const cache = this.getCachedPage('page', 'index', 'contents')
      cache ? this.done(cache) : this.getHomePage()
    },
    /**
     * Get the page data from the API
     * @method getHomePage
     * @return {void}
     */
    getHomePage () {
      const url = this.$root.routes.find(route => route.url.includes('/index')).url
      this.$http(url)
        .then(response => {
          this.done(response.data.payload.contents)
        })
    },
    /**
     * Process the data from API or from the cache
     * @method done
     * @param {object} response [response=null]
     * @return {void}
     */
    done (response = null) {
      this.contents = this.parseExternalHtml(response)
      this.$nextTick(() => {
        this.emitRouteChange()
        this.setLastBreadcrumbsItemText(lang.start)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue